<template>
  <b-container fluid>
    <b-row v-if="event">
      <b-col md="6">
        <data-section v-for="(section, index) in dataSections" :section="section" :key="index"></data-section>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import API from '@/lib/api'
import DataSection from '@/components/DataSection'

export default {
  name: 'Events',
  components: {
    'data-section': DataSection
  },
  props: ['id', 'token'],
  data () {
    return {
      breadcrumbs: [{text: 'My Vos Voco', to: '/'}, {text: 'View Event Media', to: `/events/${this.id}/media/${this.token}`, active: true}],
      event: null
    }
  },
  computed: {
    dataSections () {
      if (this.event) {
        return this.event.data_sections.filter((section) => { return section.section_type !== 'event_history' && section.section_type !== 'form' })
      } else {
        return []
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      API.get(`events/${this.id}/media`, {token: this.token}, this.$store.getters.authHeaders)
        .then((response) => {
          this.event = response.data
        })
    },
    terminology (term, fallback) {
      const terms = this.event.event_type.text_terms
      if (terms != null && terms[term] != null) {
        return terms[term]
      } else {
        return fallback
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/EventMedia.vue